export enum View {
  DASHBOARD = 'DASHBOARD',
  CALENDAR = 'CALENDAR',
  SCHEDULER = 'SCHEDULER',
  AI_ASSISTANT = 'AI_ASSISTANT',
  SETTINGS = 'SETTINGS',
  TOOLS = 'TOOLS',
  FOCUS = 'FOCUS'
}

export interface Note {
  id: string;
  date: string; // ISO date string YYYY-MM-DD
  content: string;
  color?: string;
}

export interface Task {
  id: string;
  title: string;
  subject: string;
  durationMinutes: number;
  priority: 'High' | 'Medium' | 'Low';
  deadline?: string;
  completed: boolean;
  scheduledDate?: string; // If placed on the calendar
}

export interface StudySession {
  id: string;
  taskId: string;
  startTime: string;
  endTime: string;
}

export interface AppState {
  deadline: string | null;
  notes: Note[];
  tasks: Task[];
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: number;
}